<template>
  <div>
    <span class="subtitle1">
      {{ $t("connectors.psa.addPsaConnector.connectwise.subtitle") }}
    </span>
    <div>
      {{ $t("connectors.psa.addPsaConnector.connectwise.description") }}
    </div>
    <v-form ref="form" v-model="valid" validate-on="input" class="mb-5">
      <!--    Intergration name will be added when multiple support for connectors implemented -->
      <!--    <v-text-field-->
      <!--        v-model="localValue.item.integrationName"-->
      <!--        data-testid="add-admin-modal-firstname"-->
      <!--        class="mt-6 mb-2"-->
      <!--        variant="outlined"-->
      <!--        :rules="required"-->
      <!--        :label="$t('modals.addConnectwiseConnector.integrationName.label')"-->
      <!--        :placeholder="$t('modals.addConnectwiseConnector.integrationName.placeholder')"-->
      <!--    ></v-text-field>-->
      <v-text-field
        v-model="localValue.item.companyName"
        data-testid="add-admin-modal-lastname"
        class="mt-6 mb-2"
        :rules="[required()]"
        variant="outlined"
        :label="$t('modals.addConnectwiseConnector.companyName.label')"
        :aria-label="$t('modals.addConnectwiseConnector.companyName.label')"
        :placeholder="$t('modals.addConnectwiseConnector.companyName.placeholder')"
      ></v-text-field>
      <v-text-field
        v-model="localValue.item.domain"
        data-testid="add-admin-modal-email"
        class="mt-6 mb-2"
        variant="outlined"
        :rules="[required()]"
        :label="$t('modals.addConnectwiseConnector.domain.label')"
        :aria-label="$t('modals.addConnectwiseConnector.domain.label')"
        :placeholder="$t('modals.addConnectwiseConnector.domain.placeholder')"
      ></v-text-field>
      <v-text-field
        v-model="localValue.item.publicKey"
        data-testid="add-admin-modal-email"
        class="mt-6 mb-2"
        variant="outlined"
        :rules="[required()]"
        :label="$t('modals.addConnectwiseConnector.publicKey.label')"
        :aria-label="$t('modals.addConnectwiseConnector.publicKey.label')"
        :placeholder="$t('modals.addConnectwiseConnector.publicKey.placeholder')"
      ></v-text-field>
      <v-text-field
        v-model="localValue.item.privateKey"
        data-testid="add-admin-modal-email"
        class="mt-6 mb-2"
        variant="outlined"
        :rules="[required()]"
        :label="$t('modals.addConnectwiseConnector.privateKey.label')"
        :aria-label="$t('modals.addConnectwiseConnector.privateKey.label')"
        :placeholder="$t('modals.addConnectwiseConnector.privateKey.placeholder')"
      ></v-text-field>
      <!--    <v-checkbox-->
      <!--        v-model="localValue.item.ticketingEnabled"-->
      <!--        :label="$t('modals.addConnectwiseConnector.enableTicketing')"-->
      <!--    ></v-checkbox>-->
      <!--    <v-checkbox-->
      <!--        v-model="localValue.item.billingEnabled"-->
      <!--        :label="$t('modals.addConnectwiseConnector.enableBilling')"-->
      <!--    ></v-checkbox>-->
    </v-form>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from "vue";
import cloneDeep from "lodash/cloneDeep";
import { usePsaStore } from "@/_store/connectors/psa.module";
import { storeToRefs } from "pinia";
import { required } from "@/_helpers/validators";

const defaultConnectwiseConnectConfig = {
  integrationName: "",
  companyName: "",
  domain: "",
  publicKey: "",
  privateKey: "",
  ticketingEnabled: false,
  billingEnabled: false,
};

export default defineComponent({
  props: {
    config: {
      type: Object,
      required: true,
    },
  },
  emits: ["cancel", "update:valid", "update:value"],
  setup(props, { emit }) {
    const psaStore = usePsaStore();
    const localValue = ref({
      item: cloneDeep(props.config.item ?? defaultConnectwiseConnectConfig),
    });

    const valid = ref(true);
    const { loading } = storeToRefs(psaStore);

    const form = ref();

    watch(
      valid,
      (newVal) => {
        if (newVal === null) {
          return;
        }

        emit("update:valid", newVal);
      },
      { immediate: false }
    );

    watch(
      localValue,
      async (value) => {
        emit("update:value", value.item);
      },
      { deep: true }
    );

    const cancel = () => {
      emit("cancel");
    };

    return {
      localValue,
      valid,
      form,
      required,
      cancel,
      loading,
    };
  },
});
</script>

<style scoped lang="scss"></style>
